export const Service = entityService => {
    return {
        getList(filter, sort, order, format = null) {
            return entityService.getList(filter, null, sort, order, format);
        },

        getPaginatedList(filter, page, sort, order) {
            return entityService.getList(filter, page, sort, order);
        },

        getFeatures(filter) {
            return entityService.getFeatures(filter);
        },

        getBySearchText(searchText) {
            return entityService.getBySearchText(searchText);
        },

        get(id) {
            return entityService.get(id);
        },

        create(data) {
            return entityService.create(data);
        },

        update(data) {
            return entityService.update(data);
        },

        updateWithPatch(data) {
            return entityService.updateWithPatch(data);
        },

        getMetadata(metadata) {
            return fetch(`/metadata/${metadata}`);
        },
    };
};

export default Service;
